import React from 'react';
import MainHeader from './MainHeader';

const PageLayout = ({ children }) => {
    return (
        <div className="gloabal-wrapper">
            <MainHeader />
            <main className="main-wrapper">
                {children}
            </main>
        </div>
    )
};

export default PageLayout;


// WEBPACK FOOTER //
// ./src/components/shared/PageLayout.js